// The six axis directions, in material-group order. A direction identifies the
// slab face oriented that way (decor) and the viewpoint to look from (camera).
// Single source of the literal; dependency-free so any layer (renderer, resolver,
// schema, forms) can import it.
export const FACE_DIRECTIONS = ["top", "bottom", "north", "south", "east", "west"] as const

export type FaceDirection = typeof FACE_DIRECTIONS[number]

// The four side faces that can carry edge banding (Bekantung).
export const EDGE_DIRECTIONS = ["north", "south", "east", "west"] as const
export type EdgeDirection = typeof EDGE_DIRECTIONS[number]

// The two flat faces (Oben/Unten) driven by the board decor.
export const SURFACE_DIRECTIONS = ["top", "bottom"] as const
export type SurfaceDirection = typeof SURFACE_DIRECTIONS[number]
